import React from "react";

import { Week } from "@/client/api";
import { StockMap, totalConsumedPerRecipe } from "@/client/pages/plan/types";

export function StockCoverageBadge({
  week,
  stockMap,
  consumptionMap,
  needsStock,
}: {
  week: Week;
  stockMap: StockMap;
  consumptionMap: Map<string, number>;
  needsStock: Set<string>;
}) {
  const consumed = totalConsumedPerRecipe(consumptionMap);
  const needed = new Map<string, number>();
  for (const slot of week.slots)
    for (const r of slot.recipes) {
      if (!needsStock.has(r.recipe_id)) continue;
      needed.set(r.recipe_id, (needed.get(r.recipe_id) ?? 0) + r.servings);
    }
  if (needed.size === 0) return null;
  let totalServings = 0;
  let coveredServings = 0;
  for (const [id, qty] of needed) {
    const remaining = Math.max(0, qty - (consumed.get(id) ?? 0));
    totalServings += remaining;
    coveredServings += Math.min(stockMap.get(id)?.servings ?? 0, remaining);
  }
  if (totalServings === 0) return null;
  const pct = Math.round((coveredServings / totalServings) * 100);
  const color = pct >= 80 ? "text-term-user" : pct >= 40 ? "text-term-accent" : "text-term-error";
  const bg = pct >= 80 ? "bg-term-user" : pct >= 40 ? "bg-term-accent" : "bg-term-error";
  return (
    <div className="flex items-center gap-2">
      <span className={`text-sm font-semibold ${color}`}>{pct}%</span>
      <span className="text-sm text-term-text-muted">stock</span>
      <div className="w-16 h-1.5 rounded-full bg-term-raised overflow-hidden">
        <div className={`h-full rounded-full transition-all ${bg}`} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
